import { useState } from "react";
import { Mail } from "lucide-react";
import { api } from "@/lib/api";
import { BrandLockup } from "@/shell/CandidateFlow";

const T = {
  ink: "#17131F", paper: "#FBFAFE", accent: "#7A6BE0",
  slate: "#7C7590", border: "#E4E0F4", white: "#FFFFFF",
};

export function FindMyPortal() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const res = await api.post<{ ok: boolean; error?: string }>(
        "/candidate/find-portal",
        { email }
      );
      if (res.ok) {
        setSent(true);
      } else {
        setError(res.error ?? "Something went wrong.");
      }
    } catch {
      setError("Could not connect. Please try again.");
    }
    setLoading(false);
  }

  return (
    <div style={{ minHeight: "100dvh", background: T.paper }}>
      <div style={{ padding: "48px 24px 36px", textAlign: "center" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 2 }}>
          <BrandLockup />
        </div>
        <h1 style={{ margin: "10px 0 6px", fontSize: 26, fontWeight: 700, color: T.ink }}>
          Find my portal
        </h1>
        <p style={{ margin: 0, fontSize: 14, color: T.slate }}>
          Enter your email and we'll send you links to your interview sessions.
        </p>
      </div>

      <div style={{ display: "flex", justifyContent: "center", padding: "32px 16px" }}>
        <div style={{ width: "100%", maxWidth: 400, background: T.white, borderRadius: 16,
          boxShadow: "0 24px 64px rgba(27,26,36,0.10), 0 4px 12px rgba(27,26,36,0.06)", padding: "32px 28px" }}>

          {sent ? (
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  width: 56, height: 56, borderRadius: "50%",
                  background: "rgba(122,107,224,0.1)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  margin: "0 auto 16px",
                }}
              >
                <Mail size={26} strokeWidth={1.75} color={T.accent} />
              </div>
              <p style={{ margin: "0 0 8px", fontSize: 15, fontWeight: 600, color: T.ink }}>Check your inbox</p>
              <p style={{ margin: 0, fontSize: 14, color: T.slate, lineHeight: 1.6 }}>
                If we have any sessions for {email}, you'll receive links shortly.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {error && (
                <div style={{ marginBottom: 16, padding: "12px 14px", background: "#FEF2F2",
                  borderRadius: 8, border: "1px solid #FECACA" }}>
                  <p style={{ margin: 0, fontSize: 13, color: "#B91C1C" }}>{error}</p>
                </div>
              )}
              <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: T.ink, marginBottom: 6 }}>
                Email address
              </label>
              <input
                type="email" value={email} required autoFocus
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                style={{ display: "block", width: "100%", padding: "11px 14px", fontSize: 15,
                  border: `1px solid ${T.border}`, borderRadius: 8, outline: "none",
                  color: T.ink, background: T.paper, boxSizing: "border-box" }}
              />
              <button
                type="submit" disabled={loading || !email.includes("@")}
                style={{ display: "block", width: "100%", marginTop: 16, padding: "13px 0",
                  fontSize: 15, fontWeight: 600, color: T.white,
                  background: loading ? T.slate : T.accent, border: "none", borderRadius: 8,
                  cursor: loading ? "default" : "pointer" }}>
                {loading ? "Sending…" : "Send my links"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
